import { useDispatch } from 'react-redux';
import { redirect } from 'redux-first-router';
import { ROUTE_DASHBOARD } from '@/constants/routes';

import { AuthenticationRedirect } from './AuthenticationRedirect';
import { NativeAuthenticationRedirect } from './NativeAuthenticationRedirect';

export const Home = () => {
  const dispatch = useDispatch();

  if (RUNTIME_ENV === 'native') return <NativeAuthenticationRedirect />;

  return (
    <AuthenticationRedirect
      onRedirect={() => dispatch(redirect({ type: ROUTE_DASHBOARD }))}
    />
  );
};
